import { createFetcher } from '../contexts/Fetcher';
import { useIntParams } from '../hooks/useIntParams';
import { useContext } from 'react';
import { OrganizationContext } from '../contexts/OrganizationContext';
import { apiOrganizationProduct } from '../resources/api/apiOrganizationProduct';

interface IUrlParams {
  customer_product_id: string;
}

const { useGetOrganizationProductLicenses } = apiOrganizationProduct;

export const CustomerProductLicensesFetcher = createFetcher(() => {
  const { customer_product_id } = useIntParams<IUrlParams>();
  const { organization } = useContext(OrganizationContext);

  return useGetOrganizationProductLicenses(organization ?? void 0, customer_product_id).execute;
});
